// The text pages' frame (About, Help, Terms, Privacy, Account): brand + page name and links to the others. Its own small
// module so the pages' text loads only when one is opened (D5); web/account.ts needs the frame at startup.
import { el } from "./dom.ts";
import { BRAND } from "../shared/brand.ts";

/** The text pages and their routes, for the frame's links */
const DOC_PAGES = [["About", "#/about"], ["Help", "#/help"], ["Terms", "#/terms"], ["Privacy", "#/privacy"]] as const;
export type DocPage = (typeof DOC_PAGES)[number][0] | "Account";

/** Page frame shared with the listing analyzer's look: brand + page name, links to the map and the other pages. */
export function frame(root: HTMLElement, page: DocPage, body: HTMLElement) {
  document.body.classList.add("listing-mode");
  document.title = `${BRAND.name} – ${page}`;
  const others = DOC_PAGES.filter(([p]) => p !== page).map(([p, href]) => el("a", { class: "btn small ghost", href }, p));
  root.replaceChildren(el("div", { class: "listing doc" },
    el("header", { class: "report-head" },
      el("div", { class: "brand" }, el("img", { class: "logo-mark", src: "/favicon.svg", alt: "" }), BRAND.parts[0], el("span", {}, BRAND.parts[1]), el("span", { class: "muted" }, `· ${page}`)),
      el("div", { class: "doc-nav" }, ...others, el("a", { class: "btn small ghost", href: "#/" }, "← Map"))),
    body));
  window.scrollTo(0, 0);
}

/** Static page text: written here, never from user input, so it's set as HTML. */
export function prose(html: string) {
  const d = el("div", { class: "report-card doc-body" });
  d.innerHTML = html;
  return d;
}
